type OrganizationCompanyDataCellProps = {
  label: React.ReactNode
  children: React.ReactNode
  interactive?: boolean
  onActivate?: () => void
}

export function OrganizationCompanyDataCell({
  label,
  children,
  interactive,
  onActivate,
}: OrganizationCompanyDataCellProps) {
  return (
    <div className="grid gap-1">
      <div className="text-xs font-medium text-muted-foreground">{label}</div>
      {interactive ? (
        <button
          type="button"
          className="text-start text-sm text-primary underline-offset-4 hover:underline"
          onClick={onActivate}
        >
          {children}
        </button>
      ) : (
        <div className="text-sm">{children}</div>
      )}
    </div>
  )
}
